<template>
  <div>
    <slot/>
  </div>
</template>

<script setup>
import Highcharts from "@/highcharts"
import { onMounted } from "vue"

const props = defineProps({
  year1: Number,
  data: Array,
})

onMounted(() => {
  const {
    year1, data,
  } = props

  const options = {
    xAxis: { tickInterval: 3, labels: { rotation: -45, align: "right" } },
    legend: {
      enabled: false,
    },
  }

  new Highcharts.chart({
    ...options,
    chart: { renderTo: "private", zoomType: "xy" },
    title: { text: "" },
    subtitle: { text: "Private ABA-Approved Schools" },
    tooltip: { pointFormat: '<span style="color:{series.color}"></span>{series.name}: <b>{point.y}</b><br/>', shared: true, crosshairs: true },
    yAxis: [
      { // total dollars
        gridLineWidth: 1,
        title: { text: "Tuition", style: { color: "#4572A7" } },
        labels: { formatter() {
                    return `$${this.value / 1000}k`
                  },
                  style: { color: "#4572A7" } },
        opposite: false,
        endOnTick: true,
        min: 0,
        max: 60000,
      },
    ],
    series:
      [
        {
          name: `Inflation-Adjusted from ${year1} Baseline`, type: "spline", color: "#21150F", marker: { enabled: false, symbol: "circle" }, yAxis: 0,
          data: data.filter(item => item.schools_privates_tuition_avg).map(item => ({
            y: item.schools_privates_base,
            x: item.year,
          })),
          dashStyle: "shortdot",
        },
        {
          name: "Private Tuition", type: "spline", color: "#21150F", yAxis: 0, marker: { enabled: false, symbol: "circle" },
          data: data.filter(item => item.schools_privates_tuition_avg).map(item => ({
            y: item.schools_privates_tuition_avg,
            x: item.year,
          })),
        },
      ],
  })

  new Highcharts.chart({
    ...options,
    chart: { renderTo: "public-res", zoomType: "xy" },
    title: { text: "" },
    subtitle: { text: "Public ABA-Approved Schools" },
    tooltip: { pointFormat: '<span style="color:{series.color}"></span>{series.name}: <b>{point.y}</b><br/>', shared: true, crosshairs: true },
    yAxis: [
      { // total dollars
        gridLineWidth: 1,
        title: { text: "Resident Tuition", style: { color: "#4572A7" } },
        labels: { formatter() {
                    return `$${this.value / 1000}k`
                  },
                  style: { color: "#4572A7" } },
        opposite: false,
        endOnTick: true,
        min: 0,
        max: 60000,
      },
    ],
    series:
      [
        {
          name: `Inflation-Adjusted from ${year1} Baseline`, dashStyle: "shortdot", type: "spline", marker: { enabled: false, symbol: "circle" }, color: "#4572A7", yAxis: 0,
          data: data.filter(item => item.schools_publics_res_tuition_avg).map(item => ({
            y: item.schools_publics_res_base,
            x: item.year,
          })),
        },
        {
          name: "Public (Resident) Tuition", type: "spline", color: "#4572A7", marker: { enabled: false, symbol: "circle" }, yAxis: 0,
          data: data.filter(item => item.schools_publics_res_tuition_avg).map(item => ({
            y: item.schools_publics_res_tuition_avg,
            x: item.year,
          })),
        },
      ],
  })

  new Highcharts.chart({
    ...options,
    chart: { renderTo: "public-nonres", zoomType: "xy" },
    title: { text: "" },
    subtitle: { text: "Public ABA-Approved Schools" },
    tooltip: { pointFormat: '<span style="color:{series.color}"></span>{series.name}: <b>{point.y}</b><br/>', shared: true, crosshairs: true },
    yAxis: [
      { // total dollars
        gridLineWidth: 1,
        title: { text: "Non-resident Tuition", style: { color: "#4572A7" } },
        labels: { formatter() {
                    return `$${this.value / 1000}k`
                  },
                  style: { color: "#4572A7" } },
        opposite: false,
        endOnTick: true,
        min: 0,
        max: 60000,
      },
    ],
    series:
      [
        {
          name: `Inflation-Adjusted from ${props.year1} Baseline`, dashStyle: "shortdot", type: "spline", color: "#AA4643", yAxis: 0,
          data: data.filter(item => item.schools_publics_nonres_tuition_avg).map(item => ({
            y: item.schools_publics_nonres_base,
            x: item.year,
          })),
          marker: { enabled: false, symbol: "circle" },
        },
        {
          name: "Public (Non-resident) Tuition", type: "spline", color: "#AA4643", yAxis: 0,
          data: data.filter(item => item.schools_publics_nonres_tuition_avg).map(item => ({
            y: item.schools_publics_nonres_tuition_avg,
            x: item.year,
          })),
          marker: { enabled: false, symbol: "circle" },
        },
      ],
  })
})
</script>
